import { LoadingOverlay, Paper, Stack } from "@mantine/core";
import EditModelEmail from "./emails/EditModelEmail";
import { useCallback, useEffect, useState } from "react";
import EditModelLinkedin from "./linkedin/EditModelLinkedin";
import { getModelTypeProps } from "./modelUtils";
import EditSignature from "../senders/signatures/EditSignature";
import { useParams } from "react-router-dom";
import EditModelSmv from "./smv/EditModelSmv";
import EditModelLinkedinVocal from "./linkedin/EditModelLinkedinVocal";
import { useProfileStore } from "../../../stores/UserStore";

const ModelPageEdit = ({ onEdited }) => {
  const { modelType, modelId } = useParams();
  const [modelProfile, setModelProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (modelId) {
      setLoading(true);
      const f = getModelTypeProps(modelType)?.findFunction;
      f(parseInt(modelId))
        .then((response) =>
          setModelProfile(
            modelType === "email-signature"
              ? response.data.email_signature_profile
              : response.data.model_profile,
          ),
        )
        .finally(() => setLoading(false));
    }
  }, [modelId, modelType]);

  const getComponent = useCallback(() => {
    if (modelType === "email") {
      return (
        <EditModelEmail
          model={modelProfile}
          onEdited={onEdited}
          handleClose={onEdited}
        />
      );
    }
    if (modelType === "email-signature") {
      return (
        <EditSignature
          model={modelProfile}
          onEdited={onEdited}
          handleClose={onEdited}
        />
      );
    }
    if (modelType === "linkedin-invitation") {
      return (
        <EditModelLinkedin
          type={"linkedin_invitation"}
          model={modelProfile}
          onEdited={onEdited}
          handleClose={onEdited}
        />
      );
    }
    if (modelType === "linkedin-voice-message") {
      return (
        <EditModelLinkedinVocal
          model={modelProfile}
          onEdited={onEdited}
          handleClose={onEdited}
        />
      );
    }
    if (modelType === "linkedin-message") {
      return (
        <EditModelLinkedin
          type={"linkedin_message"}
          model={modelProfile}
          onEdited={onEdited}
          handleClose={onEdited}
          maxChars={9999}
        />
      );
    }
    if (modelType === "sms") {
      return (
        <EditModelLinkedin
          type={"sms"}
          model={modelProfile}
          onEdited={onEdited}
          handleClose={onEdited}
          maxChars={
            useProfileStore.getState().profile?.id === 1125 ? 9999 : 160
          }
        />
      );
    }
    if (modelType === "smv") {
      return (
        <EditModelSmv
          model={modelProfile}
          onEdited={onEdited}
          handleClose={onEdited}
        />
      );
    }
  }, [modelProfile, modelType]);

  return (
    <Paper
      component={Stack}
      gap={"xs"}
      p={"lg"}
      pos={"relative"}
      h={"100%"}
      mb={16}
      style={{ boxShadow: "#00000012 0 2px 6px", overflow: "hidden" }}
      pt={52}
    >
      {loading ? <LoadingOverlay visible /> : getComponent()}
    </Paper>
  );
};

export default ModelPageEdit;
